import { render, staticRenderFns } from "./Kundenumsaetze.vue?vue&type=template&id=6357798c&"
import script from "./Kundenumsaetze.vue?vue&type=script&lang=js&"
export * from "./Kundenumsaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports